import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Emails from '@/pages/emails';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Emails />} />
    </Routes>
  );
}
